import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-0a4827b3")

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_BaseInput = _resolveComponent("BaseInput")
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")

  return (_openBlock(), _createBlock("div", null, [
    (_ctx.inputVisible)
      ? (_openBlock(), _createBlock(_component_BaseInput, {
          key: 0,
          modelValue: _ctx.searchString,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.searchString = $event)),
          name: "searchString",
          placeholder: "Search...",
          class: "ml-2 w-68"
        }, null, 8, ["modelValue"]))
      : _createCommentVNode("", true),
    _createVNode("button", {
      class: ["ml-3 p-2 w-9 h-9 rounded-md", _ctx.inputVisible ? 'bg-btn-primary' : 'bg-white'],
      onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.toggleInput && _ctx.toggleInput(...args)))
    }, [
      _createVNode(_component_font_awesome_icon, {
        class: _ctx.inputVisible ? 'text-white' : 'text-icon-dark',
        key: _ctx.searchIcon,
        icon: _ctx.searchIcon
      }, null, 8, ["class", "icon"])
    ], 2)
  ]))
})